import SubscriptionPlansTable from '@modules/subscriptions/SubscriptionPlansTable';
import { useParams } from 'react-router-dom';

const CompanySubscriptionPlans = () => {
    const { id } = useParams<{ id: string }>();

    return <SubscriptionPlansTable fixedProId={id} showTitle />;
};

export default CompanySubscriptionPlans;
